import React from "react";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import resumeLink from "../Assets/CV_aw.pdf";
import Halftone from "./Halftone";

function Hero() {
  return (
    <section id="top" className="relative overflow-hidden px-6 pt-28 pb-9 md:pt-36 md:pb-16">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-56 left-[30%] h-[560px] w-[900px] max-w-none bg-[radial-gradient(closest-side,rgba(143,209,106,0.16),transparent)]"
      />
      <div className="relative max-w-5xl mx-auto lg:grid lg:grid-cols-[minmax(0,1fr)_360px] lg:items-start lg:gap-10">
        <div>
          <p className="flex items-center gap-2.5 font-mono text-dim text-[13px]">
            <span className="w-1.5 h-1.5 rounded-full bg-leaf" aria-hidden="true" />
            Software developer in Uppsala, Sweden
          </p>
          <h1 className="mt-3 text-[44px] leading-[1.06] tracking-[-0.035em] sm:text-6xl md:text-[88px] md:leading-[0.98] md:tracking-[-0.04em] font-semibold text-fg">
            Andreas Wallin
          </h1>
          <p className="mt-6 max-w-[46ch] md:[text-wrap:balance] text-lg md:text-xl text-body leading-relaxed">
            I build Python tools for image processing and computer vision, and the occasional app
            around them.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2">
            <a
              href="#work"
              className="inline-flex items-center h-11 px-5 rounded-md bg-leaf text-ink text-sm font-semibold hover:bg-leaf-hover transition-colors"
            >
              See my work
            </a>
            <a
              href={resumeLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center h-11 px-5 rounded-md border border-line text-fg text-sm font-medium hover:border-leaf transition-colors"
            >
              Download CV
            </a>
            <span className="hidden sm:flex items-center ml-1">
              <a
                href="https://github.com/AndreasFWallin"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
                className="w-11 h-11 flex items-center justify-center text-xl text-dim hover:text-fg transition-colors"
              >
                <FaGithub />
              </a>
              <a
                href="https://www.linkedin.com/in/andreas-wallin-abb4b515a"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-11 h-11 flex items-center justify-center text-lg text-dim hover:text-fg transition-colors"
              >
                <FaLinkedinIn />
              </a>
            </span>
          </div>

          <div className="sm:hidden mt-4 flex gap-6 text-sm">
            <a
              href="https://github.com/AndreasFWallin"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 py-2 text-dim hover:text-fg"
            >
              <FaGithub aria-hidden="true" /> GitHub
            </a>
            <a
              href="https://www.linkedin.com/in/andreas-wallin-abb4b515a"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 py-2 text-dim hover:text-fg"
            >
              <FaLinkedinIn aria-hidden="true" /> LinkedIn
            </a>
          </div>
        </div>
        <Halftone className="hidden lg:block w-[360px] h-[96px] lg:mt-[12px]" />
      </div>
    </section>
  );
}

export default Hero;
